import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { itemsSearch } from "../../../services/app";
import ItemMerchandise from "../../../components/ItemMerchandise";
import { SearchIcon } from "../../../components/Icons/SearchIcon";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import useDebounce from "../../../hook/useDebounce";
import { ITEM_TYPES, ITEM_LIMIT } from "../../../constants";
import { useWindowSize } from "../../../hook/useWindowSize";

export const TabMerchandise = (props) => {
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const { T, setLoading, language, user } = useApp();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataTab, setDataTab] = useState([]);
  const [filterText, $filterText] = useState("");
  const debouneFilterText = useDebounce(filterText, 500);
  const [filterData, $filterData] = useState({
    name: "",
    size: ITEM_LIMIT,
    itemTypes: [ITEM_TYPES.ITEM_TYPE_PHYSICAL],
  });

  useEffect(() => {
    handleFilterData({ name: debouneFilterText });
  }, [debouneFilterText]);

  const loadData = async () => {
    setLoading(true);
    const result = await itemsSearch(filterData);
    setDataTab(result?.data?.data?.items?.rows || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setLoading(false);
  };
  const loadMore = async () => {
    setLoading(true);
    const result = await itemsSearch({
      ...filterData,
      page: page + 1,
    });
    setDataTab((prev) => [...prev, ...result?.data?.data?.items?.rows] || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setPage(page + 1);
    setLoading(false);
  };

  const handleFilterData = (val) => {
    $filterData({ ...filterData, ...val });
  };

  useEffect(() => {
    loadData();
  }, [filterData]);

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] mt-[10px]">
      <div className="search-input relative">
        <SearchIcon className="absolute left-[16px] top-[12px]" />
        <input
          type="text"
          className="h-[40px] outline-none pl-[50px] w-full max-w-full px-5 py-3 bg-white rounded-[10px] text-black "
          placeholder={T("Type anything to search")}
          onChange={(e) => $filterText(e.target.value)}
        />
      </div>
      <div className="flex justify-between items-start gap-[50px]">
        <div className={`flex-1 w-full`}>
          <div className="asset-block">
            {dataTab?.length > 0 ? (
              <>
                <div
                  className={`grid gap-[15px] grid-cols-1 xs:gap-[10px] lg:grid-cols-4 lg:gap-[30px] xl:gap-[50px]`}
                >
                  {dataTab.map((item, index) => (
                    <ItemMerchandise key={index} itemData={item} />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
                  <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                    <img
                      className="w-[100px] lg:w-[160px]"
                      src={"/assets/images/empty-table.png"}
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center mb-[15px]">
                    {T("You haven't got anything yet.")}
                  </div>
                  <a
                    href={`${user.store_shopify}?lang=${language}`}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-black leading-[45px] !text-white rounded-[15px] px-[20px] h-[45px] button-boxshadow"
                  >
                    {T("Go to Mall")}
                  </a>
                </div>
              </>
            )}
          </div>
          {total > page * filterData.size && (
            <>
              <div
                className="flex justify-center items-center gap-[10px] mt-[40px]"
                onClick={() => loadMore()}
              >
                {T("Load more")} <ArrowDownIcon />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
